import { Personality } from '../@core/constants';
import { Address } from './address';
import { Phone } from './phone';


export class PersonalInfo {
  personality: Personality;
  fiscalId: string;
  fiscalIdType: string;
  fiscalId2: string;
  fiscalIdType2: string;
  name: string;
  relationship: string;
  middleName: string;
  lastName: string;
  lastName2: string;
  familyName: string;
  gender: string;
  birthdate: string;
  nationality: string;
  age: number;
  maritalStatus: string;
  email: string;
  email2: string;
  dependents: number;
  ownCar: boolean;
  profession: string;
  incomeSource: string;
  universityDegree: string;
  lastDegree: string;
  fullName: string;
  addresses: Array<Address>;
  phones: Array<Phone>;
  constructor() {
    this.personality = Personality.PERSON;
    this.fiscalId = '';
    this.fiscalIdType = '';
    this.fiscalId2 = '';
    this.fiscalIdType2 = '';
    this.name = '';
    this.relationship = '';
    this.middleName = '';
    this.lastName = '';
    this.lastName2 = '';
    this.familyName = '';
    this.gender = '';
    this.birthdate = '';
    this.nationality = '';
    this.age = 0;
    this.maritalStatus = '';
    this.email = '';
    this.email2 = '';
    this.dependents = 0;
    this.ownCar = false;
    this.profession = '';
    this.incomeSource = '';
    this.universityDegree = '';
    this.lastDegree = '';
    this.fullName = '';
    this.addresses = [];
    this.phones = [];
  }

  getFullName() {
    return `${this.name} ${this.middleName} ${this.lastName} ${this.lastName2}`.trim();
  }

  getHomeAddress() {
    return this.addresses.find(f => f.type == "DOMICILIO") ?? new Address();
  }

  getFirstMobilePhone(): Phone {
    return this.phones.filter(f => f.type == "MOVIL")[0] ?? new Phone();
  }

  getFirstHomePhone(): Phone {
    return this.phones.filter(f => f.type == "CASA")[0] ?? new Phone();
  }
}
